import { AbstractControl, ValidationErrors } from "@angular/forms";

export function emailFormatValidator(control: AbstractControl): ValidationErrors | null {
    if (!control.value) return null;
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/;
    return emailRegex.test(control.value?.trim()) ? null : { emailInvalid: true };
}